import { Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import lineLogin from "../../img/line_login.png";
import { ColorHexCodes } from "../../util/Color";
import type { ReservationState } from "../../util/useReservationState";
import CancellableReservationSummary from "../CancellableReservationSummary";
import { FormWrapper } from "../FormWrapper";
import { useGTMWithEvent } from "../GTM/useGTMwithEvent";
import Space from "../Space";

export default function Done({ state }: { state: ReservationState }) {
  useGTMWithEvent(state.data.store?.google_tag_manager_id ?? "", "CompleteRegistration");
  useEffect(() => window.scrollTo(0, 0), []);

  if (!state.data.rid || !state.data.store || !state.data.course || !state.data.date) {
    state.setValue("error", true);
    return null;
  }

  return (
    <FormWrapper currentIndex={4} skipConfirm={state.data.store?.skip_confirm}>
      {state.data.lineLoginUrl && (
        <div>
          <Stack alignItems="center" direction="row" spacing={2}>
            <Typography>LINEログインして予約通知を受け取る</Typography>
            <a href={state.data.lineLoginUrl} rel="noopener noreferrer" target="_blank">
              <img alt="Line login" height="32" src={lineLogin} width="110" />
            </a>
          </Stack>

          <Space h={15} />
          <div style={{ background: `#${ColorHexCodes.MainColorGreen}`, height: 1 }} />
          <Space h={15} />
        </div>
      )}

      <CancellableReservationSummary data={{ ...state.data, course: state.data.course, date: state.data.date, nominated_staff: state.data.staff ?? null, rid: state.data.rid, store: state.data.store }} />
      <Space h={40} />
    </FormWrapper>
  );
}
